import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { logError, logInfo } from '@utils/logger';

export const usePOIManager = (surveyId) => {
  const [pois, setPOIs] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!surveyId) {
      setLoading(false);
      setPOIs([]);
      setRoutes([]);
      return;
    }

    logInfo(`Loading data for survey: ${surveyId}`);
    setLoading(true);

    // Set up POIs listener
    const poisRef = collection(db, 'pois');
    const poisQuery = query(
      poisRef,
      where('surveyId', '==', surveyId)
    );
    
    // Set up Routes listener
    const routesRef = collection(db, 'routes');
    const routesQuery = query(
      routesRef,
      where('surveyId', '==', surveyId)
    );

    // Subscribe to POIs
    const unsubscribePOIs = onSnapshot(poisQuery, 
      snapshot => {
        const poisData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setPOIs(poisData);
        logInfo(`Loaded ${poisData.length} POIs`);
      },
      error => {
        logError('Error loading POIs:', error);
        setPOIs([]);
      }
    );

    // Subscribe to Routes
    const unsubscribeRoutes = onSnapshot(routesQuery,
      snapshot => {
        const routesData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setRoutes(routesData);
        logInfo(`Loaded ${routesData.length} routes`);
      },
      error => {
        logError('Error loading routes:', error);
        setRoutes([]);
      }
    );

    setLoading(false);

    return () => {
      unsubscribePOIs();
      unsubscribeRoutes();
    };
  }, [surveyId]);

  return { pois, routes, loading };
};